import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import access_ControlActions from "../../Actions/Access_ControlActions";
import access_ControlConstants from "../../Constants/Access_ControlConstants";
import commonUtils from "../../helpers/commonUtils";
import access_ControlStore from "../../Stores/Access_ControlStores";
import { useLanguageContext } from "../../Context/LanguageContext";
import {
  useAlertMessageContext,
  useAlertMessageActionsContext,
} from "../../Context/AlertMessageContext";
import AlertMessage from "../MessageBox/AlertMessage";

const ChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const { localization } = useLanguageContext();
  const { showAlertMessage, isAlertSuccess, alertMessage } =
    useAlertMessageContext();
  const { setAlertMessageFromAPI } = useAlertMessageActionsContext();
  const passwordChange = (e) => {
    e.preventDefault();
    setAlertMessageFromAPI(false, false, localization.passwordDontMatch);
    if (newPassword !== confirmPassword) {
      setAlertMessageFromAPI(true, false, localization.passwordDontMatch);
    } else {
      const changePass = {
        ID: sessionStorage.getItem("userid"),
        OldPassword: currentPassword,
        NewPassword: newPassword,
      };
      access_ControlActions.changePassword(changePass);
      setTimeout(() => {
        setShowMessage(false);
      }, 5000);
      // commonUtils.hideModalPopUp("changePasswordClose");
    }
  };

  useEffect(() => {
    function getChangePasswordSuccess() {
      const res = access_ControlStore.getChangePassword();
      if (res) {
        setShowMessage(true);
        setMessage(localization.passwordChangeSuccessfully);
      }
      setConfirmPassword("");
      setCurrentPassword("");
      setNewPassword("");
    }

    function getChangePasswordFailure() {
      const res = access_ControlStore.getChangePassword();
      setShowMessage(true);
      setMessage(res);
      setConfirmPassword("");
      setCurrentPassword("");
      setNewPassword("");
    }

    access_ControlStore.addChangeListener(
      access_ControlConstants.CHANGE_PASSWORD_SUCCESS,
      getChangePasswordSuccess
    );

    access_ControlStore.addChangeListener(
      access_ControlConstants.CHANGE_PASSWORD_FAILURE,
      getChangePasswordFailure
    );

    return () => {
      access_ControlStore.removeChangeListener(
        access_ControlConstants.CHANGE_PASSWORD_SUCCESS,
        getChangePasswordSuccess
      );

      access_ControlStore.removeChangeListener(
        access_ControlConstants.CHANGE_PASSWORD_FAILURE,
        getChangePasswordFailure
      );
    };
  }, []);
  const CheckForMessage = () => {
    if (showMessage) {
      return (
        <span className="alert alert-success alert-dismissible fade show text-center">
          {message}
        </span>
      );
    } else {
      return "";
    }
  };

  function handleClose() {
    setConfirmPassword("");
    setCurrentPassword("");
    setNewPassword("");
    setAlertMessageFromAPI(false, false, localization.passwordDontMatch);
  }

  return (
    <div
      className="modal fade"
      id="changePassword"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="changePassword"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="changePassword">
              {localization.changePassword}
            </h5>
            <CheckForMessage />
            <AlertMessage
              showAlertMessage={showAlertMessage}
              isAlertSuccess={isAlertSuccess}
              alertmessage={alertMessage}
            />
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="changePasswordClose"
              onClick={handleClose}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <form
              id="changePassword"
              autoComplete="off"
              onSubmit={passwordChange}
            >
              <div className="row mb-4">
                <div className="col">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="changePassword">
                      {localization.currentPassword}
                    </label>
                    <input
                      type="password"
                      id="currentPassword"
                      name="currentPassword"
                      className="form-control mb-2"
                      placeholder={localization.currentPassword}
                      required
                      value={currentPassword}
                      onChange={(e) => {
                        setCurrentPassword(e.target.value);
                      }}
                    />

                    <label className="form-label" htmlFor="changePassword">
                      {localization.newPassword}
                    </label>
                    <input
                      type="password"
                      id="newPassword"
                      name="newPassword"
                      className="form-control mb-2"
                      placeholder={localization.newPassword}
                      required
                      value={newPassword}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                      }}
                    />

                    <label className="form-label" htmlFor="changePassword">
                      {localization.confirmPassword}
                    </label>
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      className="form-control"
                      placeholder={localization.confirmPassword}
                      required
                      value={confirmPassword}
                      onChange={(e) => {
                        setConfirmPassword(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <button type="submit" className="btn btn-primary btn-block mb-4">
                {localization.save}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
